import Documents from './Documents.container.jsx';

export default Documents;